<template>
  <div>
    <div class="greenBorderBottom">
      <div class="numberContainer">
        <p class="bigNumberStyle">{{deskNumber}}</p>
      </div>
      <div class="textContainer">
        <div>
          <div>
            <p class="greenTitle">{{deskTitle}}</p>
          </div>
        </div>
        <div>
          <div>
            <p class="greySubTitle">{{deskSubtitle}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: ['deskNumber', 'deskTitle', 'deskSubtitle'],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/var";
  .bigNumberStyle{
    font-size: 40px;
    margin: 0;
    text-align: right;
    font-weight: 400;
  }
  .greenTitle{
    font-size: 18px;
    color: #AAD500;
    margin: 0;
    text-align: left;
    font-weight: 700;
  }
  .greySubTitle{
    color: #707070;
    font-weight: 700;
    text-align: left;
    font-size: 11px;
    margin: 0;
    text-transform: uppercase;
  }
  .greenBorderBottom:after {
    content: "";
    display: block;
    width: 100%;
    margin: 0 auto;
    border-bottom: 6px solid #AAD500;
  }
  .numberContainer{
    display: inline-block;
  }
  .textContainer{
    display: inline-block;
  }
  @media only screen and (max-width: 767px) {
    .greenTitle {
      font-size: 9px;
    }
    .greySubTitle {
      font-size: 9px;
    }
    .bigNumberStyle {
      font-size: 20px;
      font-weight: 700;
    }.greenBorderBottom:after {
       border-bottom: 3px solid #AAD500;
     }
  }
</style>
